// ABOUTME: A feeling's face drawn in a round ring of the feeling's hue: the 2A scene's 66px ring, or the same ring scaled to any size.
// ABOUTME: The 2A scene and the cloud stack's base tier both draw it, so the face looks the same on both.

import type { ComponentProps } from 'react';
import { Box } from '@mui/material';
import { CROSSING_FACE_FILL, CROSSING_NEUTRAL_FILL, FEELING_HUES } from '../../../theme/crossingTokens';
import FeelingFaceIcon from './FeelingFaceIcon';

export const FEELING_RING_SIZE = 66;
export const FEELING_ICON_SIZE = 54;
const FEELING_RING_BORDER = 3;

type FeelingFaceRingProps = { code: string; size?: number } & Omit<ComponentProps<typeof Box>, 'children' | 'size'>;

export default function FeelingFaceRing({ code, size = FEELING_RING_SIZE, sx, ...rest }: FeelingFaceRingProps) {
  const hue = FEELING_HUES[code] ?? CROSSING_NEUTRAL_FILL;
  const scale = size / FEELING_RING_SIZE;
  return (
    <Box
      {...rest}
      sx={{
        width: size, height: size, boxSizing: 'border-box', borderRadius: '50%', border: `${FEELING_RING_BORDER * scale}px solid ${hue}`,
        backgroundColor: CROSSING_FACE_FILL, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ...sx,
      }}
    >
      <FeelingFaceIcon code={code} hue={hue} size={FEELING_ICON_SIZE * scale} />
    </Box>
  );
}
